module.exports = __webpack_public_path__ + "img/lx_kclb.0d81f244.svg";